import { Injectable } from '@angular/core';
import { IListResponseWrapper } from '../../core/model/v2-api/v2-api-wrappers';
import { V2RunLaneIndexSummary } from '../../core/bsshapi/api-wrappers';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { ErrorMessages } from '../../core/utilities/error-messages';
import { BsApiEndPoints } from '../../core/services/bs-api/endpoints';
import { retryWhen, delay } from 'rxjs/operators';
import { genericRetryWhen, observableEmitDelay } from '../../core/rxjsutils/rxjs-utilities';

export interface IRunLaneIndexService {
  getLaneIndexSummaries(runId: string): Observable<IListResponseWrapper<V2RunLaneIndexSummary>>;
}

@Injectable({
  providedIn: 'root'
})
export class RunLaneIndexService implements IRunLaneIndexService {

  constructor(private httpClient: HttpClient) { }

  getLaneIndexSummaries(runId: string): Observable<IListResponseWrapper<V2RunLaneIndexSummary>> {

    if (!runId) {
      return throwError(ErrorMessages.RUN_INDEX_QC.NO_RUN_SPECIFIED);
    }

    const requestUrl = BsApiEndPoints.getRunLaneIndexSummaryUrl(runId);

    return this.httpClient.get<IListResponseWrapper<V2RunLaneIndexSummary>>(requestUrl).pipe(
      // Retry in case of HTTP errors
      retryWhen(genericRetryWhen()),
      // To avoid a Flash of content, maintain a delay
      delay(observableEmitDelay),
    );
  }
}
